/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useReactForm } from "../react-hook/use-react-form";
import { IconRender } from "@/components/shared/Icon-render";
import { Switch } from "@/components/ui/switch";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { ArrayInput, SelectWithSearch } from "@/components/form-input";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useEffect, useState } from "react";
import { useWatch } from "react-hook-form";
// import { IgnorePriceValidations } from "../ignore-price-validations";
import { cn } from "@/lib/utils";
import { IgnorePriceValidationsV2 } from "../ignore-price-validations-v2";

type UserFormType = {
  workflowList: any;
  sncErpUomList: string[];
  order_status_list: any[];
  formData: any;
  activeTab: any;
  sku_list: any;
  sncCustomerList: any;
  onErpSettingsTabChange: any;
  onFormSubmit: (prop: boolean) => Promise<void>;
  reloadData: any;
};
export const ReactForm = ({
  formData,
  onFormSubmit,
  workflowList,
  activeTab,
  sncErpUomList,
  order_status_list,
  sncCustomerList,
  onErpSettingsTabChange,
  sku_list,
  reloadData,
}: UserFormType) => {
  const { form, onSubmit, show, setShow } = useReactForm({
    formData,
    onFormSubmit,
  });

  const [passwordHandle, setPasswordHandle] = useState<boolean>(true);
  useEffect(() => {
    if (formData) {
      setTimeout(() => {
        setPasswordHandle(false);
      }, 300);
    }
  }, [formData]);

  const sncErpUomListArr = sncErpUomList.map((item) => ({
    value: item,
    label: item,
  }));

  const erp_sku_validations = useWatch({
    control: form.control,
    name: "erp_sku_validations",
  });
  const erp_price_validations = useWatch({
    control: form.control,
    name: "erp_price_validations",
  });
  const support_multi_doc_type = useWatch({
    control: form.control,
    name: "support_multi_doc_type",
  });

  useEffect(() => {
    if (erp_sku_validations === false) {
      form.setValue("sku_similarity_search", false);
      form.setValue("customer_sku_search", false);
    }
  }, [erp_sku_validations]);

  useEffect(() => {
    if (erp_price_validations) {
      onErpSettingsTabChange();
    }
  }, [erp_price_validations]);
  useEffect(() => {
    if (formData?.erp_price_validations && activeTab === "erp_settings") {
      onErpSettingsTabChange();
    }
  }, [activeTab]);

  return (
    <div className="md:h-[calc(100dvh-227px)] overflow-y-auto">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="divide-solid divide-y px-6 ">
            {activeTab === "company_settings" ? (
              <>
                <FormField
                  control={form.control}
                  name="ignore_validation_failure"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4">
                        <FormLabel>Ignore validation failure</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px]">
                          <Switch
                            checked={field.value}
                            onCheckedChange={field.onChange}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormItem className="flex p-[12px_0px_23px_0px]">
                  <div className="w-[250px] pt-4">
                    <FormLabel>Duplicate order settings</FormLabel>
                  </div>
                  <FormMessage />
                </FormItem>
                <FormField
                  control={form.control}
                  name="amend_and_push_duplicate"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4 pl-10">
                        <FormLabel>Amend and push order</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px]">
                          <Switch
                            checked={field.value}
                            onCheckedChange={field.onChange}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="do_not_push_duplicate"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px] ">
                      <div className="w-[250px] pt-4 pl-10">
                        <FormLabel>Do not push duplicate</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px]">
                          <Switch
                            checked={field.value}
                            onCheckedChange={field.onChange}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="push_duplicate"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4 pl-10">
                        <FormLabel>Push Duplicate</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px]">
                          <Switch
                            checked={field.value}
                            onCheckedChange={field.onChange}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="disable_snc_auto_push"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4">
                        <FormLabel>Disable auto push</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px]">
                          <Switch
                            checked={field.value}
                            onCheckedChange={field.onChange}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="push_flagged_documents"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4">
                        <FormLabel>Push Flagged Documents</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px]">
                          <Switch
                            checked={field.value}
                            onCheckedChange={field.onChange}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="detect_chinese_text"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4">
                        <FormLabel>Detect chinese text</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px]">
                          <Switch
                            checked={field.value}
                            onCheckedChange={field.onChange}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="default_workflow"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-6">
                        <FormLabel>Default workflow</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px] w-[calc(100%_-_250px)]">
                          <SelectWithSearch
                            bindLabel="name"
                            bindValue="workflow_id"
                            placeholder="Select workflow"
                            options={workflowList}
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="default_uom"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-6">
                        <FormLabel>Default UOM</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px] w-[calc(100%_-_250px)]">
                          <SelectWithSearch
                            bindLabel="label"
                            bindValue="value"
                            placeholder="Select UOM"
                            options={sncErpUomListArr}
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="reference_number_prefix"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-6">
                        <FormLabel>Reference number prefix</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px] w-[calc(100%_-_250px)]">
                          <Input
                            placeholder="Reference number prefix"
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="order_status"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-6">
                        <FormLabel>Order status</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px] w-[calc(100%_-_250px)]">
                          <SelectWithSearch
                            bindLabel="label"
                            bindValue="value"
                            placeholder="Select Order Status"
                            options={order_status_list}
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="support_multi_doc_type"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4">
                        <FormLabel>Support multi doc type</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px]">
                          <Switch
                            checked={field.value}
                            onCheckedChange={field.onChange}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="decimal_places"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4">
                        <FormLabel>Qty decimal places</FormLabel>
                      </div>
                      <FormControl>
                        <div className="relative w-full pl-[22px] pr-[23px]">
                          <FormControl>
                            <Input
                              type={"number"}
                              className="break-all"
                              placeholder="Qty decimal places"
                              value={field.value}
                              onChange={field.onChange}
                            />
                          </FormControl>
                          <FormMessage />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="amount_decimal_places"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4">
                        <FormLabel>Amount decimal places</FormLabel>
                      </div>
                      <FormControl>
                        <div className="relative w-full pl-[22px] pr-[23px]">
                          <FormControl>
                            <Input
                              type={"number"}
                              className="break-all"
                              placeholder="Amount decimal places"
                              value={field.value}
                              onChange={field.onChange}
                            />
                          </FormControl>
                          <FormMessage />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="match_sale_history_uom_by_sku"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4">
                        <FormLabel>Match sale history uom by sku</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px]">
                          <Switch
                            checked={field.value}
                            onCheckedChange={field.onChange}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="show_deleted_documents"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4">
                        <FormLabel>Show deleted documents</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px]">
                          <Switch
                            checked={field.value}
                            onCheckedChange={field.onChange}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormItem className="flex p-[12px_0px_23px_0px]">
                  <div className="w-[250px] pt-4">
                    <FormLabel>Customer mapping settings</FormLabel>
                  </div>
                  <FormMessage />
                </FormItem>
                <FormField
                  control={form.control}
                  name="show_branch_id"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4 pl-10">
                        <FormLabel>Show branch id</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px]">
                          <Switch
                            checked={field.value}
                            onCheckedChange={field.onChange}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                {support_multi_doc_type ? (
                  <>
                    <div className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4">
                        <FormLabel>Multi doc detection keys</FormLabel>
                      </div>
                    </div>

                    <FormField
                      control={form.control}
                      name="multi_doc_detection_keys.daily_sales_report"
                      render={({ field }) => (
                        <FormItem className="flex p-[12px_0px_23px_0px]">
                          <div className="w-[250px] pt-4 pl-10">
                            <FormLabel>Daily sales report</FormLabel>
                          </div>
                          <FormControl>
                            <div className="pt-2 pl-0 ml-[-22px] w-[calc(100%_-_250px)]">
                              <ArrayInput
                                value={field.value || []}
                                onChange={field.onChange}
                              />
                            </div>
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                    <FormField
                      control={form.control}
                      name="multi_doc_detection_keys.bank_deposit_slip"
                      render={({ field }) => (
                        <FormItem className="flex p-[12px_0px_23px_0px]">
                          <div className="w-[250px] pt-4 pl-10">
                            <FormLabel>Bank deposit slip</FormLabel>
                          </div>
                          <FormControl>
                            <div className="pt-2 pl-0 ml-[-22px] w-[calc(100%_-_250px)]">
                              <ArrayInput
                                value={field.value || []}
                                onChange={field.onChange}
                              />
                            </div>
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                    <FormField
                      control={form.control}
                      name="multi_doc_detection_keys.pos_payout_receipt"
                      render={({ field }) => (
                        <FormItem className="flex p-[12px_0px_23px_0px]">
                          <div className="w-[250px] pt-4 pl-10">
                            <FormLabel>Pos payout receipt</FormLabel>
                          </div>
                          <FormControl>
                            <div className="pt-2 pl-0 ml-[-22px] w-[calc(100%_-_250px)]">
                              <ArrayInput
                                value={field.value || []}
                                onChange={field.onChange}
                              />
                            </div>
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </>
                ) : null}
                <FormField
                  control={form.control}
                  name="comments"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4">
                        <FormLabel>Comments</FormLabel>
                      </div>
                      <div className="relative w-full pl-[22px] pr-[23px]">
                        <FormControl>
                          <Textarea
                            rows={2}
                            placeholder="Comments"
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                          />
                        </FormControl>
                        <FormMessage />
                      </div>
                    </FormItem>
                  )}
                />
              </>
            ) : null}

            {activeTab === "erp_settings" ? (
              <>
                <FormField
                  control={form.control}
                  name="erp_enabled"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4">
                        <FormLabel>Erp Enabled</FormLabel>
                      </div>
                      <FormControl>
                        <div className="pt-2 pl-0 ml-[-22px]">
                          <Switch
                            checked={field.value}
                            onCheckedChange={field.onChange}
                          />
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <ConditionRenderer
                  condition={form.watch("erp_enabled") ? true : false}
                >
                  <FormField
                    control={form.control}
                    name="erp_price_validations"
                    render={({ field }) => (
                      <FormItem className="flex p-[12px_0px_23px_0px]">
                        <div className="w-[250px] pt-4 pl-10">
                          <FormLabel>Erp price validations</FormLabel>
                        </div>
                        <div className="flex items-center">
                          <FormControl>
                            <div className="pt-2 pl-0 ml-[-22px]">
                              <Switch
                                checked={field.value}
                                onCheckedChange={(prop) => {
                                  field.onChange(prop);
                                  if (prop) {
                                    reloadData();
                                  }
                                }}
                              />
                            </div>
                          </FormControl>
                        </div>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </ConditionRenderer>

                <div
                  className={cn(
                    form.watch("erp_price_validations") ? "" : "hidden",
                  )}
                >
                  <FormField
                    control={form.control}
                    name="ignore_price_validations"
                    render={({ field: { value, onChange } }) => (
                      <>
                        <IgnorePriceValidationsV2
                          list={sncCustomerList}
                          form={form}
                          value={value || []}
                          onChange={onChange}
                          sku_list={sku_list || []}
                          onSubmit={() => form.handleSubmit(onSubmit)()}
                        />
                      </>
                    )}
                  />
                </div>
                <ConditionRenderer
                  condition={form.watch("erp_enabled") ? true : false}
                >
                  <FormField
                    control={form.control}
                    name="erp_sku_validations"
                    render={({ field }) => (
                      <FormItem className="flex p-[12px_0px_23px_0px]">
                        <div className="w-[250px] pt-4 pl-10">
                          <FormLabel>Erp sku validations</FormLabel>
                        </div>
                        <FormControl>
                          <div className="pt-2 pl-0 ml-[-22px]">
                            <Switch
                              checked={field.value}
                              onCheckedChange={field.onChange}
                            />
                          </div>
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </ConditionRenderer>
                <ConditionRenderer
                  condition={form.watch("erp_enabled") ? true : false}
                >
                  <div className="flex">
                    <FormField
                      control={form.control}
                      name="sku_similarity_search"
                      render={({ field }) => (
                        <FormItem className="flex p-[12px_0px_23px_0px]">
                          <div className="w-[250px] pt-4 pl-10">
                            <FormLabel>Sku Similarity Search</FormLabel>
                          </div>
                          <FormControl>
                            <div className="pt-2 pl-0 ml-[-22px]">
                              <Switch
                                disabled={erp_sku_validations === false}
                                checked={field.value}
                                onCheckedChange={field.onChange}
                              />
                            </div>
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                    <FormField
                      control={form.control}
                      name="customer_sku_search"
                      render={({ field }) => (
                        <FormItem className="flex p-[12px_0px_23px_0px] w-1/2">
                          <div className="pt-4 pl-10">
                            <FormLabel>Customer Sku Search</FormLabel>
                          </div>
                          <FormControl>
                            <div className="pt-2 pl-[23px]">
                              <Switch
                                disabled={erp_sku_validations === false}
                                checked={field.value}
                                onCheckedChange={field.onChange}
                              />
                            </div>
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </div>
                </ConditionRenderer>
                <ConditionRenderer
                  condition={form.watch("erp_enabled") ? true : false}
                >
                  <FormField
                    control={form.control}
                    name="erp_uom_validations"
                    render={({ field }) => (
                      <FormItem className="flex p-[12px_0px_23px_0px]">
                        <div className="w-[250px] pt-4 pl-10">
                          <FormLabel>Erp uom validations</FormLabel>
                        </div>
                        <FormControl>
                          <div className="pt-2 pl-0 ml-[-22px]">
                            <Switch
                              checked={field.value}
                              onCheckedChange={field.onChange}
                            />
                          </div>
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </ConditionRenderer>
                <FormField
                  control={form.control}
                  name="snc_username"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4">
                        <FormLabel>Snc Username</FormLabel>
                      </div>
                      <div className="relative w-full pl-[22px] pr-[23px]">
                        <FormControl>
                          <Input
                            type={"text"}
                            className="break-all"
                            placeholder="Snc Username"
                            value={field.value}
                            onChange={field.onChange}
                          />
                        </FormControl>
                        <FormMessage />
                      </div>
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="snc_password"
                  render={({ field }) => (
                    <FormItem className="flex p-[12px_0px_23px_0px]">
                      <div className="w-[250px] pt-4">
                        <FormLabel>Snc Password</FormLabel>
                      </div>
                      <div className="relative w-full  pl-[22px] pr-[23px]">
                        <FormControl>
                          <Input
                            type={show ? "text" : "password"}
                            className="break-all"
                            placeholder="Snc Password"
                            value={field.value}
                            onChange={field.onChange}
                            autoComplete="off"
                            name="notpassword"
                            readOnly={passwordHandle}
                          />
                        </FormControl>
                        <div className="absolute right-5 top-0">
                          <Button
                            variant={"ghost"}
                            type="button"
                            onClick={() => setShow(!show)}
                          >
                            <IconRender name={show ? "EyeOff" : "Eye"} />
                          </Button>
                        </div>
                        <div className="pt-1">
                          <FormMessage />
                        </div>
                      </div>
                    </FormItem>
                  )}
                />
              </>
            ) : null}
          </div>
          <hr className="mt-5" />
          <DialogFooter className="p-6 flex !justify-start">
            <Button
              type="submit"
              className="w-[150px]"
              disabled={form.formState.isSubmitting}
            >
              {form.formState.isSubmitting ? (
                <IconRender
                  name="LoaderCircle"
                  className="w-5 animate-spin text-white zoom-in-150"
                />
              ) : (
                "Save"
              )}
            </Button>
          </DialogFooter>
        </form>
      </Form>
    </div>
  );
};
